import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import tetrazolioService, { TetrazolioItem, TetrazolioListResponse } from '../../../../services/sementes/tetrazolio';
import useTetrazolioFilters from './useTetrazolioFilters';
import useTetrazolioOrder from './useTetrazolioOrder';
import { selectTopBarState } from '../../../../components/Topbar/topBarSlice';

export type { OrderOption } from './useTetrazolioOrder';
export type { FilterValues } from './useTetrazolioFilters';

export interface TetrazolioHookData {
  data: TetrazolioItem[];
  loading: boolean;
  error: string | null;
  meta: TetrazolioListResponse['meta'] | null;
  refetch: () => void;

  formik: any;
  clearFilters: () => void;
  changePage: (page: number) => void;

  selectedOrder: any;
  changeOrder: (option: any) => void;
}

export default function useTetrazolio(): TetrazolioHookData {
  const [data, setData] = useState<TetrazolioItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [meta, setMeta] = useState<TetrazolioListResponse['meta'] | null>(null);

  const { currentProdutor } = useSelector(selectTopBarState);
  const filtersHook = useTetrazolioFilters('tz');
  const orderHook = useTetrazolioOrder('tz');

  const fetchData = useCallback(async () => {
    if (!currentProdutor?.id) {
      setData([]);
      setMeta(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const params = filtersHook.getFiltersFromURL();
      const response = await tetrazolioService.list({
        ...params,
        produtorId: currentProdutor.id,
        determinacao: 'TZ',
      });

      setData(response.data);
      setMeta(response.meta);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar dados');
      setData([]);
      setMeta(null);
    } finally {
      setLoading(false);
    }
  }, [filtersHook.getFiltersFromURL, currentProdutor?.id]);

  const refetch = useCallback(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    meta,
    refetch,
    formik: filtersHook.formik,
    clearFilters: filtersHook.clearFilters,
    changePage: filtersHook.changePage,
    selectedOrder: orderHook.selectedOrder,
    changeOrder: orderHook.changeOrder,
  };
}
